import { useState, useRef, useMemo, useEffect } from 'react'
import ReactPlayer from 'react-player'
import { Modal, Spin, notification } from 'antd'
import { LeftOutlined, RightOutlined, CloseOutlined } from '@ant-design/icons'
import videoConfferenceApi from 'src/api/videoConferenceApi'
import useGetWithContext from 'src/hooks/useGetWithContext'
import { useTranslation } from 'next-i18next'

const defaultDimension = { width: '100%', height: '100%' }
export default function ModalVideoSessionTrack ({ session, visible, onClose }) {
  const { t } = useTranslation()
  const [currentUrlIndex, setCurrentUrlIndex] = useState(0)
  const divRef = useRef(null)
  const [dimension, setDimension] = useState(defaultDimension)

  const { data: recordDetail, status } = useGetWithContext(`GET_RECORD_SESSION_${session?.code}`, videoConfferenceApi.getSessionRecordDetail, session?.code, { isDisabled: !session?.code })
  
  const urlList = useMemo(() => {
    return recordDetail?.classInData?.recordUrls
  }, [recordDetail])

  const handleClose = () => {
    onClose()
    if (currentUrlIndex !== 0) {
      setCurrentUrlIndex(0)
    }
  }

  const onReady = () => {
    setDimension(defaultDimension)
  }

  const keepDimension = () => {
    const rect = divRef.current.getBoundingClientRect()
    setDimension({ width: rect.width, height: rect.height })
  }
  const handleClose1 = (e) => {
    e.stopPropagation()
    const target = e.target
    if (target.className === 'wrapx') {
      handleClose()
    }
  }

  const goBack = () => {
    keepDimension()
    if (currentUrlIndex > 0) {
      setCurrentUrlIndex(currentUrlIndex - 1)
    } else {
      setCurrentUrlIndex(urlList.length - 1)
    }
  }
  const goNext = () => {
    keepDimension()
    if (currentUrlIndex < urlList.length - 1) {
      setCurrentUrlIndex(currentUrlIndex + 1)
    } else {
      setCurrentUrlIndex(0)
    }
  }
  const goSpecificIndex = (idx) => {
    if (idx !== currentUrlIndex) {
      keepDimension()
      setCurrentUrlIndex(idx)
    }
  }

  const onEnded = () => {
    if (urlList.length && currentUrlIndex !== urlList.length - 1) {
      goNext()
    }
  }

  useEffect(()=> {
    if (status != "loading" && !urlList?.length) {
      notification.warning({
        message: t('common.label.not_video'),
      })
      onClose()
    }
  }, [urlList, status])

  if (status == "loading" || !urlList?.length) return <></>
  return (
    <>
      <Modal visible={visible} onCancel={handleClose} footer={null} destroyOnClose width='100%' bodyStyle={{ padding: '0 0' }} closable={false} className='link-video'>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '100%', position: 'absolute', left: 0, top: 0 }} className='wrapx' onClick={handleClose1}>
          <Spin spinning={dimension.width !== defaultDimension.width}>
            <div style={{ position: 'relative', ...dimension, maxWidth: 1000 }} ref={divRef}>
              <ReactPlayer
                url={urlList[currentUrlIndex]}
                width='100%'
                height='100%'
                playing
                controls
                onReady={onReady}
                onEnded={onEnded}
                stopOnUnmount
              />
              {urlList.length >= 2 &&
                <div className='play-list'>
                  <span className='ant-modal-close-x' onClick={goBack}><LeftOutlined /></span>
                  <VideoIndex currentIndex={currentUrlIndex} setCurrentUrlIndex={goSpecificIndex} urlList={urlList} />
                  <span className='ant-modal-close-x' onClick={goNext}><RightOutlined /></span>
                </div>}
              <span className='ant-modal-close-x' style={{ position: 'absolute', top: 0, right: 0 }} onClick={handleClose}><CloseOutlined /></span>
            </div>
          </Spin>
        </div>
      </Modal>
    </>
  )
}

function VideoIndex ({ currentIndex, setCurrentUrlIndex, urlList }) {
  const items = urlList.map((_, idx) => {
    return <span key={idx} className='ant-modal-close-x' style={{ fontWeight: currentIndex === idx ? 'bold' : 'unset', textDecoration: currentIndex === idx ? 'underline' : 'unset', cursor: 'default' }} onClick={() => setCurrentUrlIndex(idx)}>{idx + 1}</span>
  })
  return <>{items}</>
}
